<div class="notes-header">
    <p-dialog
            header="Search Contacts"
            [modal]="true"
            [(visible)]="displayContactSearchModal"
            [style]="{ width: '67rem', border: '0px' }"
            class="custom-dialog"
            styleClass="contact-search-dialog dialogStylePadding"
            (onHide)="onDialogHide()"
    >
        <ng-template #cmcLoading>
            <div class="custom-class-loader">
                <div class="spinner-container">
                    <img src="assets/qwyn/icons/spinner.gif" alt="Loading" class="loader">
                </div>
            </div>
        </ng-template>
               <ngx-loading [show]="showCmcSpinner" [config]="{ backdropBorderRadius: '3px' }"
                         [template]="cmcLoading"></ngx-loading>

        <div class="p-fluid">
            <div>
                <!-- Search input and advanced search on the same line -->
                <div class="search-input-container">
                    <span class="p-text-secondary">General Search:</span>
                    <div class="search-with-suggestions">
                        <div class="search-container">
                            <input
                                #generalSearchInput
                                type="text"
                                placeholder="Search by Name, Email, or Group DL (at least 3 characters)"
                                [(ngModel)]="query"
                                (input)="filterItem(generalSearchInput.value)"
                            />
                            <img class="search-icon" [src]="'assets/Inbox/searchContact.svg'" alt="search" />
                            <img *ngIf="query" class="clear-icon" src="assets/Inbox/orangeClose.svg" alt="clear" (click)="clearSearch()"/>
                        </div>

                        <!-- Suggestions List -->
                        <div class="suggestions-container" *ngIf="filteredItems.length > 0">
                            <div
                                    class="suggestion-item"
                                    *ngFor="let item of filteredItems"
                                    (click)="selectItem(item)"
                            >
                                <div class="suggestion-details">
                                    <div class="name">{{item.text}}</div>
                                    <div class="email">{{item.value}}</div>
                                    <div class="id">{{item.value}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="suggestions-container" *ngIf="searchPerformed && filteredItems.length === 0 && generalSearchInput.value.length >= 3">
                            <div class="suggestion-item no-results">
                                No results found
                            </div>
                        </div>
                    </div>
                    <div
                            class="advanced-search-link"
                            *ngIf="!isAdvancedSearch"
                            (click)="callCmcSearchWindow()"
                    >
                        Advanced Search
                    </div>
<!--
                    <div
                            class="back-link"
                            *ngIf="isAdvancedSearch"
                            (click)="backToGeneralSearch()"
                    >
                        <div class="closeText">Close Search</div>
                        <img class="closeIcon" [src]="'assets/Inbox/orangeClose.svg'" alt="Close" />
                    </div>
-->
                </div>

                <!-- Advanced Search Link -->

                <!-- Buttons aligned center -->
                <div *ngIf="!isAdvancedSearch" class="buttons-container ">
                    <p-button
                            label="Cancel"
                            (onClick)="showHideContactSearch()"
                            styleClass="p-button-danger me-2"
                    ></p-button>
                </div>
            </div>

            <!-- Advanced Search View -->
            <div *ngIf="isAdvancedSearch" class="advanced-search-container">
                <div class="input-group search-by-type-div">
                    <div class="form-group search-by-section flex flex-row">
                        <label for="radio-group-div" class="form-label mb-0">Search by:</label>
                        <div id="radio-group-div" class="radio-group preference-radio">
                            <p-radioButton name="searchType" value="USER" label="User Name" [(ngModel)]="searchByOption"></p-radioButton>
                            <p-radioButton name="searchType" value="GROUP" label="Group DL Name" [(ngModel)]="searchByOption"></p-radioButton>
                        </div>
                    </div>
                </div>
                
                <div *ngIf="searchByOption === 'USER'">
                    <div class="input-group">
                        <div class="form-group">
                            <label for="adv-user-first-name" class="form-label">First Name:</label>
                            <input id="adv-user-first-name" type="text" placeholder="Type here" [(ngModel)]="advancedSearch.firstName" class="select-form-control"/>
                        </div>
                        <div class="form-group">
                            <label for="adv-user-last-name" class="form-label">Last Name:</label>
                            <input id="adv-user-last-name" type="text" placeholder="Type here" [(ngModel)]="advancedSearch.lastName" class="select-form-control"/>
                        </div>
                    </div>
                    <div class="input-group">
                        <div class="form-group">
                            <label for="adv-user-email" class="form-label">Email:</label>
                            <input id="adv-user-email" type="text" placeholder="Type here" [(ngModel)]="advancedSearch.email" class="select-form-control"/>
                        </div>
                    </div>
                </div>

                <div *ngIf="searchByOption === 'GROUP'">
                    <div class="input-group">
                        <div class="form-group">
                            <label class="form-label">Group DL:</label>
                            <input
                                    type="text"
                                    placeholder="Type here"
                                    [(ngModel)]="advancedSearch.groupDL"
                                    class="select-form-control"
                            />
                        </div>
                    </div>
                </div>
                <!-- Commented out to prevent rendering. Do not remove, Lina says we might need this in the future -->
                <!-- <div class="select-group">
                    <div class="form-group">
                        <div class="select-wrapper">
                            <select
                                    [(ngModel)]="advancedSearch.clientIdentifier"
                                    class="client-dropdown"
                            >
                                <option value="" selected="selected">
                                    Select Client Identifier
                                </option>
                                <option value="Client Name">Client Name</option>
                                <option value="GP ID">GP ID</option>
                                <option value="Mgmt ID">Mgmt ID</option>
                                <option value="Client Mnemonic">Client Mnemonic</option>
                            </select>
                        </div>

                        <input
                                type="text"
                                placeholder="Type here"
                                [(ngModel)]="advancedSearch.clientIdentifierValue"
                                class="select-form-control"
                        />
                    </div>
                </div> -->

                <div class="error-msg" *ngIf="errorMsg">{{errorMsg}}</div>

                <!-- Buttons aligned center -->
                <div class="buttons-container ">
                    <p-button
                            label="Cancel"
                            (onClick)="showHideContactSearch()"
                            styleClass="p-button-danger me-2"
                    ></p-button>
                    <p-button
                            label="Search"
                            styleClass="custom-submit-button"
                            (click)="searchCMC()"
                    ></p-button>
                </div>

                <div class="d-flex flex-row mt-4 inquiry-rule" *ngIf="search">
                    <ag-grid-angular
                        #inquiryGrid
                        style="width:100%; height:26vh;"
                        class="ag-theme-balham adminview"
                        id="cmcSearch"
                        [gridOptions]="gridOptions"
                        [rowData]="routesList"
                        [columnDefs]="routesColumn"
                        [stopEditingWhenCellsLoseFocus]="true"
                        [suppressRowClickSelection]="true"
                        [pagination]="true"
                        [defaultColDef]="defaultColDef"
                        [rowSelection]="'multiple'"
                        [paginationPageSize]="100"
                        (gridReady)="onGridReadyInquiry($event)"
                        suppressPaginationPanel="true"
                        (paginationChanged)="onPaginationChanged()"
                        [suppressDragLeaveHidesColumns]="true"
                        [headerHeight]="44"
                        [suppressHorizontalScroll]="false"
                        [modules]="modules"
                    >
                    </ag-grid-angular>
                </div>
                <div *ngIf="search" class="qma-mailbox-pagination-container">
                    <!-- Left side pagination controls -->
                    <div class="pagination-controls">
                        <img src="assets/Inbox/pagination-arrow-first.svg"
                             id="btFirst"
                             class="pagination-img"
                             [ngClass]="{'pagination-img-disabled': disablePaginationPrevFirst}"
                             (click)="onBtFirst()">
                        <img src="assets/Inbox/pagination-arrow-prev.svg"
                             id="btPrevious"
                             class="pagination-img"
                             [ngClass]="{'pagination-img-disabled': disablePaginationPrevFirst}"
                             (click)="onBtPrevious()">
                        <span class="pagination-text">Page</span>
                        <input type="number"
                               class="page-input"
                               [value]="lbCurrentPage"
                               (keydown.enter)="onPageInput($event)"
                               (blur)="onPageInput($event)"
                               min="1"
                               [max]="lbTotalPages">
                        <span class="pagination-text">of {{lbTotalPages}}</span>
                        <img src="assets/Inbox/pagination-arrow-next.svg"
                             id="btNext"
                             class="pagination-img"
                             [ngClass]="{'pagination-img-disabled': disablePaginationNextLast}"
                             (click)="onBtNext()">
                        <img src="assets/Inbox/pagination-arrow-last.svg"
                             id="btLast"
                             class="pagination-img"
                             [ngClass]="{'pagination-img-disabled': disablePaginationNextLast}"
                             (click)="onBtLast()">
                    </div>
                    <!-- Right side total records -->
                    <div class="total-records">
                        <span class="value">{{lbPageSize}}</span>
                        <span>of</span>
                        <span class="value">{{lbTotalRecords}}</span>
                        <span>Total</span>
                    </div>
                </div>
                <!-- Buttons aligned center -->
                <div *ngIf="!isAdvancedSearch" class="buttons-container" style="margin-top: 30px;">
                    <p-button label="Select" styleClass="custom-submit-button"></p-button>
                </div>

                <!-- Select Button -->
                <div *ngIf="search" class="buttons-container">
                    <p-button label="Select" styleClass="custom-submit-button" (click)="selectCMSContacts()" [disabled]="displayError">
                    </p-button>
                </div>
            </div>
        </div>
    </p-dialog>
</div>
